export enum ListViewContentElementCapability {
  labelable = 1,
  selectable = 2,
  xSizeable = 3,
  sortedByable = 4,
  propertyReferenceable = 5,
  derivedValuable = 6,
  iconImageReferencable = 7,
  viewLinkable = 8,
  formattable = 9,
  alignable = 10,
  listFormattable = 11,
}
